import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "	<div data-magellan-destination=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"information") : depth0)) != null ? lookupProperty(stack1,"sticky") : stack1), depth0))
    + "\" class=\"foundation-sticky-destination\">\r\n		<div class=\"row information-container collapse\">\r\n			<div class=\"small-12 medium-12 large-12 show-for-medium-up\">\r\n				<h2>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"information") : depth0)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "</h2>\r\n			</div>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"information") : depth0)) != null ? lookupProperty(stack1,"contents") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":3},"end":{"line":26,"column":12}}})) != null ? stack1 : "")
    + "		</div>\r\n	</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"row") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
    + "\r\n				<h3 data-position=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"position") || (depth0 != null ? lookupProperty(depth0,"position") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"position","hash":{},"data":data,"loc":{"start":{"line":15,"column":23},"end":{"line":15,"column":37}}}) : helper)))
    + "\"> "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"header") || (depth0 != null ? lookupProperty(depth0,"header") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data,"loc":{"start":{"line":15,"column":40},"end":{"line":15,"column":54}}}) : helper))) != null ? stack1 : "")
    + " </h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contents") : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":18,"column":13}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"row") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":20,"column":4},"end":{"line":25,"column":11}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "					<div class=\"row odd-content\">\r\n						<div class=\"small-12 medium-6 large-6 columns icon "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"className") || (depth0 != null ? lookupProperty(depth0,"className") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"className","hash":{},"data":data,"loc":{"start":{"line":10,"column":57},"end":{"line":10,"column":72}}}) : helper)))
    + " content-section\" data-icon=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"className") || (depth0 != null ? lookupProperty(depth0,"className") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"className","hash":{},"data":data,"loc":{"start":{"line":10,"column":101},"end":{"line":10,"column":116}}}) : helper)))
    + "\" data-background-size=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"backgroundSize") || (depth0 != null ? lookupProperty(depth0,"backgroundSize") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"backgroundSize","hash":{},"data":data,"loc":{"start":{"line":10,"column":140},"end":{"line":10,"column":160}}}) : helper)))
    + "\">\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "							<div class=\"small-12 medium-6 large-6 columns icon "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"className") || (depth0 != null ? lookupProperty(depth0,"className") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"className","hash":{},"data":data,"loc":{"start":{"line":12,"column":58},"end":{"line":12,"column":73}}}) : helper)))
    + " content-section\" data-icon=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"className") || (depth0 != null ? lookupProperty(depth0,"className") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"className","hash":{},"data":data,"loc":{"start":{"line":12,"column":102},"end":{"line":12,"column":117}}}) : helper)))
    + "\"  data-background-size=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"backgroundSize") || (depth0 != null ? lookupProperty(depth0,"backgroundSize") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"backgroundSize","hash":{},"data":data,"loc":{"start":{"line":12,"column":142},"end":{"line":12,"column":162}}}) : helper)))
    + "\">\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "					<p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    return "					</div>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "					</div>\r\n					</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"information") : depth0)) != null ? lookupProperty(stack1,"title") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":29,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/product-information-details-sbcc-module",
  "version": "1.0.3",
  "id": "productInformationDetailsSbccModule",
  "containerID": "sbCreditCardsProductInformationDetailsSbccModule",
  "moduleName": "sb-credit-cards-product-information-details-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "product-information-details-sbcc-module",
  "data": {
    "init": "ProductInformationDetailsSbccModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "isCreditSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter should be set to determine if this module is used as credit section"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* eslint-disable no-param-reassign */

/* global */

/**
 * The ProductInformationDetailsSbccModule Sparta Module.
 * sparta generate module
 * @export
 * @class
 */
class ProductInformationDetailsSbccModule extends Module {
  /**
   * Creates an instance of ProductInformationDetailsSbccModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof ProductInformationDetailsSbccModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Sets the data-magellan-destination value.
    // IF the target is the Credit Section,
    // then append Credit to the value so the product-sticky-navbar-sbcc will find it.

    const {
      target
    } = this.settings;
    target.dataset.magellanDestination = target.dataset.init;
    if (this.params.isCreditSection) {
      target.dataset.magellanDestination = `${target.dataset.init}Credit`;
    }
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    this.setIconsStyles();
  }

  /**
  * @method setIconStyles
  * @description size and position of icon and associated h3
  * @returns {void}
  */
  setIconsStyles() {
    // collect all icon divs
    const icons = this.settings.target.querySelectorAll('.icon');
    icons.forEach(icon => {
      // get icon name
      const iconName = icon.getAttribute('data-icon');
      // find icon
      const setIcon = this.settings.target.querySelector(`.${iconName}`);
      // set icon size (image set in scss)
      const backgroundSize = setIcon.getAttribute('data-background-size');
      icon.style.backgroundSize = backgroundSize;

      // get h3 with associated icon
      const h3 = this.settings.target.querySelector(`.content-section.${iconName} h3`);
      // set h3 left margin
      const position = h3.getAttribute('data-position');
      h3.style.marginLeft = position;
    });
  }
}
registerModuleClass({
  moduleClass: ProductInformationDetailsSbccModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ProductInformationDetailsSbccModule as default, moduleConfig };
